import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import NewQuoteForm from './NewQuoteForm';
import './EntrepriseQuotes.css';

const API_URL = import.meta.env.VITE_API_URL;

const EntrepriseQuotes = () => {
    const [quotes, setQuotes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showNewForm, setShowNewForm] = useState(false);

    useEffect(() => {
        fetchQuotes();
    }, []);

    const fetchQuotes = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_URL}/demandes-devis/mes-demandes`, {
                headers: {Authorization: `Bearer ${token}`}
            });
            setQuotes(response.data);
        } catch (error) {
            console.error('Erreur devis:', error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusBadge = (status) => {
        const s = status?.toLowerCase() || '';
        if (s.includes('attente') || s.includes('cours')) return <span className="status-badge warning">En attente</span>;
        if (s.includes('validé') || s.includes('trait')) return <span className="status-badge success">Validé</span>;
        if (s.includes('rejet')) return <span className="status-badge danger">Rejeté</span>;
        return <span className="status-badge info">{status}</span>;
    };

    if (showNewForm) {
        return (
            <div className="entreprise-quotes-container">
                <NewQuoteForm
                    onSuccess={() => {
                        setShowNewForm(false);
                        fetchQuotes();
                    }}
                    onCancel={() => setShowNewForm(false)}
                />
            </div>
        );
    }

    return (
        <div className="entreprise-quotes-container">
            <div className="ent-section-header">
                <div className="header-with-action">
                    <div>
                        <h2>Mes Demandes de Devis</h2>
                        <p>Retrouvez l'historique et le suivi de vos projets photovoltaïques.</p>
                    </div>
                    <button className="add-quote-btn" onClick={() => setShowNewForm(true)}>
                        + Nouveau Devis
                    </button>
                </div>
            </div>

            {loading ? (
                <LoadingSpinner message="Récupération de vos devis..." />
            ) : quotes.length === 0 ? (
                <div className="empty-state">
                    <span className="empty-icon">📁</span>
                    <h3>Aucun devis disponible</h3>
                    <p>Démarrez un projet solaire pour voir vos demandes s'afficher ici.</p>
                    <button className="primary-action-btn" onClick={() => setShowNewForm(true)} style={{marginTop: '20px'}}>
                        Créer mon premier devis
                    </button>
                </div>
            ) : (
                <div className="quotes-grid">
                    {quotes.map((quote) => (
                        <div key={quote._id} className="quote-card">
                            <div className="quote-card-header">
                                <div className="quote-type-tag">
                                    {quote.pompage ? '💧 POMPAGE' : '☀️ RÉSIDENTIEL'}
                                </div>
                                {getStatusBadge(quote.statut)}
                            </div>

                            <div className="quote-card-body">
                                <div className="quote-main-info">
                                    <span className="quote-id">REF: {quote._id.substring(quote._id.length - 8).toUpperCase()}</span>
                                    <span className="quote-date">{new Date(quote.createdAt).toLocaleDateString('fr-FR', {day: 'numeric', month: 'long', year: 'numeric'})}</span>
                                </div>

                                <div className="quote-specs">
                                    {quote.pompage ? (
                                        <>
                                            <div className="spec-item">
                                                <span>Puissance:</span>
                                                <strong>{quote.puissanceCV || 0} CV</strong>
                                            </div>
                                            <div className="spec-item">
                                                <span>Surface:</span>
                                                <strong>{quote.surfaceHectares || 0} Ha</strong>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="spec-item">
                                                <span>Puis. Commerciale:</span>
                                                <strong>{quote.puissanceCommerciale || 0} kWc</strong>
                                            </div>
                                            <div className="spec-item">
                                                <span>Économie Est.:</span>
                                                <strong>{quote.puissanceNecessaire ? (quote.puissanceNecessaire * 1.5).toFixed(1) : 0} MWh/an</strong>
                                            </div>
                                        </>
                                    )}
                                    <div className="spec-item">
                                        <span>Paiement:</span>
                                        <strong>{quote.modePaiement === 'credit' ? 'Crédit Prosol' : 'Comptant'}</strong>
                                    </div>
                                </div>

                                <div className="quote-card-footer">
                                    <button
                                        className="view-details-btn"
                                        onClick={() => Swal.fire('Dossier Technique', 'L\'accès aux documents techniques et aux contrats sera bientôt disponible.', 'info')}
                                    >
                                        Consulter le dossier
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default EntrepriseQuotes;
